import classes from "./index.module.scss";
import { ReactComponent as Image } from "../images/google.svg";

export default function GooglePlayLink() {
  return (
    <a
      className={classes.link}
      href="https://play.google.com/store/apps/details?id=io.shapely.app"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image />
      Google Play
    </a>
  );
}
